"use client";
import {
  CollectionContextProvider,
  CollectionScopedContextProvider
} from "./5CPL3B7G.js";
import {
  createStoreContext
} from "./VOQWLFSQ.js";

// src/form/form-context.tsx
var ctx = createStoreContext(
  [CollectionContextProvider],
  [CollectionScopedContextProvider]
);
var useFormContext = ctx.useContext;
var useFormScopedContext = ctx.useScopedContext;
var useFormProviderContext = ctx.useProviderContext;
var FormContextProvider = ctx.ContextProvider;
var FormScopedContextProvider = ctx.ScopedContextProvider;

export {
  useFormContext,
  useFormScopedContext,
  useFormProviderContext,
  FormContextProvider,
  FormScopedContextProvider
};
